import type { Manufacturer } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { inUseStatuses } from '../../utils/constants';
import { gql } from '@apollo/client';
import { getTenantList } from '#/graphql/queries';

const columns: ColumnProps<Manufacturer>[] = [
  { dataField: 'id', caption: 'ID', visible: false, showInColumnChooser: false },
  {
    dataField: 'name',
    caption: 'Name',
    dataType: 'string',
    visible: true,
    fixed: true,
    openOnClick: true,
    sortIndex: 0,
    sortOrder: 'desc',
  },
  {
    dataField: 'contactPerson',
    caption: 'Contact Person',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'inUseStatus',
    caption: 'Status',
    dataType: 'string',
    visible: false,
    lookup: {
      nullable: true,
      dataSource: Object.values(inUseStatuses),
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  {
    dataField: 'tenant.name',
    caption: 'Organization',
    visible: true,
    dataType: 'string',
    headerFilter: {
      getItemList: gql(getTenantList),
      displayExpr: 'name',
    },
  },
];

export default columns;
